import { timeAgo } from "@/lib/api";

const DOT = { true: "#00E676", false: "#FF3D00" };
const dot = (ok) => DOT[ok] || "#64748B";

const detail = (s) => {
  if (s.error) return s.error;
  if (s.last_run) return `synced ${timeAgo(Date.parse(s.last_run) / 1000)} · ${s.found} found`;
  return "starting…";
};

export default function SourceStatus({ sources }) {
  return (
    <section className="panel p-4" data-testid="data-source-status-widget">
      <p className="overline mb-3">data sources</p>
      <div className="grid grid-cols-1 gap-2 sm:grid-cols-2 xl:grid-cols-3">
        {sources.map((s) => (
          <div key={s.key} data-testid={`source-${s.key}`} className="rounded-md border border-[#1E2738] bg-[#0F141C] p-2.5">
            <div className="flex items-center gap-2">
              <span className="h-2 w-2 rounded-full" style={{ background: dot(s.ok) }} />
              <span className="text-xs text-slate-200">{s.name}</span>
            </div>
            <p className="mt-1 truncate font-mono text-[10px] text-slate-500" title={s.error || ""}>
              {detail(s)}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
